import React from 'react';

import { InfoField } from '@occc/ui-design-system';
import { AwardTransactionMoneyDiscountFragment } from '@occc/graphql';

interface ITransactionMoneyDiscountProps {
  award: AwardTransactionMoneyDiscountFragment;
}

export const TransactionMoneyDiscountAward: React.FC<ITransactionMoneyDiscountProps> = ({
  award,
}) => {
  return <InfoField label='Money Discount' value={award?.moneyDiscount} />;
};
